<script>
import { notify } from '@/helpers/notify'


export default {
    data() {
    return {
        title: "SMS YÖNETİMİ",
        form: {},
        formOrder: [],
        submitted:false,
        };
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
                const fill = (data) => {
                        if(!Array.isArray(data)) return;
                        // reset
                        this.form = {};
                        this.formOrder = [];
                        data.forEach(e=>{
                            const code = e.code || e.key || String(Math.random());
                            const label = e.title || e.trtitle || e.name || e.label || code;
                            const paramsArr = e.params || e.parameters || e.placeholders || [];
                            this.formOrder.push(code);
                            // ensure reactivity when adding new keys
                            this.$set(this.form, code, {
                            active: !!e.status,
                            trcontent: e.trcontent,
                            encontent: e.encontent,
                            params: Array.isArray(paramsArr) ? paramsArr : (typeof paramsArr === 'string' ? paramsArr.split(',') : []),
                            paramsString: Array.isArray(paramsArr) ? paramsArr.join(',') : (typeof paramsArr === 'string' ? paramsArr : ''),
                            label
                            });
                        })
                }

                // Use legacy endpoint that previously worked
                this.$http.post('/sms-schema')
                    .then(resp => fill(resp.data))
                    .catch(()=>{ /* ignore */ });
        },
        saveItem(code){
            const entry = this.form[code] || {};
            this.$set(entry, 'saving', true);
            let payload = {};
            payload = {
                code: code,
                status: !!entry.active,
                trcontent: entry.trcontent || '',
                encontent: entry.encontent || ''
            };
            return this.$http.put('/sms-schema', payload)
                .then(resp => {
                notify.success((resp.data && resp.data.message) || 'Güncellendi');
                this.$set(entry, 'saving', false);
                return resp;
                })
                .catch(err => {
                notify.error('Kaydetme başarısız');
                this.$set(entry, 'saving', false);
                return Promise.reject(err);
                });
        },
    },
        computed: {
            formList(){
                return this.formOrder.map(code => ({ code, ...this.form[code] }))
            }
        },
};
</script>

<template>
  <form class="needs-validation">
    <div class="row">
        <div class="col-md-12">
            <div v-if="!formOrder.length" class="text-muted">Yükleniyor veya şablon yok.</div>
            <div v-for="code in formOrder" :key="code" class="card mb-1">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <div class="fw-bold">{{ form[code].label || code }}</div>
                  <div class="d-flex align-items-center">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" v-model="form[code].active" :id="`sw-${code}`" />
                      <label class="form-check-label small text-muted" :for="`sw-${code}`">Aktif</label>
                    </div>
                    <button class="btn btn-sm btn-warning ms-2" @click="saveItem(code)" :disabled="form[code].saving">{{ form[code].saving ? 'Güncelleniyor...' : 'Güncelle' }}</button>
                  </div>
                </div>

                <div v-if="form[code].active">
                  <b-tabs content-class="mt-2">
                    <b-tab title="Türkçe">
                      <label class="form-label small">Türkçe Mesaj</label>
                      <b-form-textarea rows="2" v-model="form[code].trcontent" placeholder="Türkçe mesaj metni"></b-form-textarea>
                    </b-tab>
                    <b-tab title="İngilizce">
                      <label class="form-label small">İngilizce Mesaj</label>
                      <b-form-textarea rows="2" v-model="form[code].encontent" placeholder="English message (optional)"></b-form-textarea>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
        </div>
    </div>
    <!-- end row-->
    </form>
</template>